/* MK — interacciones de las secciones propias */

(function () {
  'use strict';

  function initReveals() {
    var elementos = document.querySelectorAll('.mk-reveal');
    if (!elementos.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      elementos.forEach(function (el) { el.classList.add('mk-visible'); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('mk-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    elementos.forEach(function (el) { observer.observe(el); });
  }

  function initGaleriaProducto() {
    var principal = document.querySelector('#mk-foto-principal img');
    var miniaturas = document.querySelectorAll('.mk-prod__miniatura');
    if (!principal || !miniaturas.length) return;

    miniaturas.forEach(function (mini) {
      mini.addEventListener('click', function () {
        principal.src = mini.getAttribute('data-mk-img');
        miniaturas.forEach(function (m) { m.classList.remove('mk-prod__miniatura--activa'); });
        mini.classList.add('mk-prod__miniatura--activa');
      });
    });
  }

  function initVariantesProducto() {
    var dataEl = document.getElementById('mk-variantes-data');
    var opciones = document.getElementById('mk-opciones');
    if (!dataEl || !opciones) return;

    var variantes;
    try {
      variantes = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var inputId = document.getElementById('mk-variant-id');
    var precio = document.getElementById('mk-precio');
    var precioAntes = document.getElementById('mk-precio-antes');
    var precioTransfer = document.getElementById('mk-precio-transfer');
    var boton = document.getElementById('mk-btn-comprar');
    var fotoPrincipal = document.querySelector('#mk-foto-principal img');
    var textoBoton = boton ? boton.textContent.trim() : '';

    function seleccionadas() {
      var valores = [];
      opciones.querySelectorAll('fieldset').forEach(function (fs) {
        var marcado = fs.querySelector('input:checked');
        valores.push(marcado ? marcado.value : null);
      });
      return valores;
    }

    function actualizar() {
      var sel = seleccionadas();
      var variante = variantes.find(function (v) {
        return v.opciones.every(function (op, i) { return op === sel[i]; });
      });
      if (!variante) return;

      if (inputId) inputId.value = variante.id;
      if (precio) precio.textContent = variante.precio;
      if (precioAntes) {
        precioAntes.style.display = variante.precio_antes ? '' : 'none';
        if (variante.precio_antes) precioAntes.textContent = variante.precio_antes;
      }
      if (precioTransfer && variante.precio_transferencia) {
        precioTransfer.textContent = variante.precio_transferencia;
      }
      if (boton) {
        boton.disabled = !variante.disponible;
        boton.textContent = variante.disponible ? textoBoton : (boton.getAttribute('data-mk-agotado') || 'Agotado');
      }
      if (fotoPrincipal && variante.imagen) {
        fotoPrincipal.src = variante.imagen;
        var base = variante.imagen.split('?')[0];
        document.querySelectorAll('.mk-prod__miniatura').forEach(function (mini) {
          var miniBase = (mini.getAttribute('data-mk-img') || '').split('?')[0];
          mini.classList.toggle('mk-prod__miniatura--activa', miniBase === base);
        });
      }
    }

    opciones.addEventListener('change', actualizar);
  }

  function initGuiaModal() {
    var abrir = document.getElementById('mk-guia-abrir');
    var modal = document.getElementById('mk-guia-modal');
    if (!abrir || !modal) return;

    function abrirModal() {
      modal.hidden = false;
      document.body.classList.add('mk-guia-open');
    }
    function cerrarModal() {
      modal.hidden = true;
      document.body.classList.remove('mk-guia-open');
    }

    abrir.addEventListener('click', abrirModal);
    modal.querySelectorAll('[data-mk-guia-cerrar]').forEach(function (el) {
      el.addEventListener('click', cerrarModal);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) cerrarModal();
    });
  }

  function initFiltroFotosPorColor() {
    var dataEl = document.getElementById('mk-media-colores');
    var opciones = document.getElementById('mk-opciones');
    var miniaturas = document.querySelectorAll('.mk-prod__miniatura');
    var contenedor = document.querySelector('.mk-prod__miniaturas');
    if (!dataEl || !opciones || !miniaturas.length) return;

    var mapa;
    try {
      mapa = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var fieldsetColor = opciones.querySelector('[data-mk-color-opcion]');
    if (!fieldsetColor) return;

    function colorSeleccionado() {
      var marcado = fieldsetColor.querySelector('input:checked');
      return marcado ? marcado.value : null;
    }

    function aplicarFiltro() {
      var color = colorSeleccionado();
      if (!color) return;
      var visibles = 0;
      miniaturas.forEach(function (mini) {
        var id = mini.getAttribute('data-mk-media-id');
        var colores = (mapa[id] || []).filter(Boolean);
        var mostrar = colores.length === 0 || colores.indexOf(color) !== -1;
        mini.style.display = mostrar ? '' : 'none';
        if (mostrar) visibles++;
      });
      if (contenedor) {
        contenedor.style.display = visibles > 1 ? '' : 'none';
      }
    }

    opciones.addEventListener('change', aplicarFiltro);
    aplicarFiltro();
  }

  function initTodo() {
    initReveals();
    initGaleriaProducto();
    initVariantesProducto();
    initGuiaModal();
    initFiltroFotosPorColor();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTodo);
  } else {
    initTodo();
  }
})();
